import moment from "moment";
import {
  TableCellType,
  TableHeader,
} from "../../../components/custom-table/table";
import {
  DetailedEventModel,
  NewEventModel,
} from "../../../data-model/eventsModal";
import { MedicalPaOrder } from "../../../data-model/medicalPaOrdersModel";
import {
  EventBadgeBgColorForUI,
  EventBadgeTextColorForUI,
  EventType,
  EventTypeTextForUI,
} from "../../../enums/eventType";
import { AuditTrialTableColumnKeys } from "../../../enums/tableColumnKeys";
import { capitalizeWordsSeperatedByUnderScore } from "../../../utils/stringModifications";

export const AuditTrialTableColumnHeaders: TableHeader[] = [
  {
    label: "Timestamp",
    key: AuditTrialTableColumnKeys.TIMESTAMP,
    order: 1,
    width: 25,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Actions",
    key: AuditTrialTableColumnKeys.ACTIONS,
    order: 1,
    width: 60,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Event Type",
    key: AuditTrialTableColumnKeys.EVENT_TYPE,
    order: 3,
    width: 15,
    type: TableCellType.BADGE,
  },
];

export const AuditTrialDetailsTableColumnHeaders: TableHeader[] = [
  {
    label: "Timestamp",
    key: AuditTrialTableColumnKeys.TIMESTAMP,
    order: 1,
    width: 25,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Actions",
    key: AuditTrialTableColumnKeys.ACTIONS,
    order: 1,
    width: 60,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "",
    key: AuditTrialTableColumnKeys.VIEW_SCREENSHOT,
    order: 3,
    width: 15,
    type: TableCellType.VIEW_ICON,
  },
];

export const generateAuditTrialTableData = (
  data: NewEventModel[],
  singleOrder: MedicalPaOrder,
) => {
  return data.map((item) => {
    return {
      [AuditTrialTableColumnKeys.TIMESTAMP]: moment(item.timestamp).format(
        "MM/DD/YYYY HH:mm:ss",
      ),
      [AuditTrialTableColumnKeys.ACTIONS]: capitalizeWordsSeperatedByUnderScore(
        checkForClickJS(item.name ?? ""),
      ),
      [AuditTrialTableColumnKeys.EVENT_TYPE]: {
        text: generateBadgeForEventType(item.tag ?? "", item.name ?? "").text,
        bgColor: generateBadgeForEventType(item.tag ?? "", item.name ?? "")
          .bgColor,
        color: generateBadgeForEventType(item.tag ?? "", item.name ?? "").color,
      },

      [AuditTrialTableColumnKeys.ROW_DATA]: {
        ...item,
        order_id: singleOrder.id,
      },
    };
  });
};

export const generateAuditTrialExhaustiveTableData = (
  data: DetailedEventModel,
) => {
  const allEntries = data.entries ?? [];
  return allEntries.map((item) => {
    const screenshotPath = item?.metadata?.screenshot_path;

    const generateAdditionalData = (item) => {
      const eventName = item?.metadata?.name?.toLowerCase();
      if (eventName?.includes("password")) {
        return `(********)`;
      }
      if (
        item?.metadata?.auth_tab_selected &&
        item?.metadata?.auth_tab_selected !== ""
      ) {
        return `( ${item?.metadata?.auth_tab_selected} )`;
      }
      if (item?.metadata?.value && item?.metadata?.value !== "") {
        return `( ${item?.metadata?.value} )`;
      }
      return "";
    };
    return {
      [AuditTrialTableColumnKeys.TIMESTAMP]: moment(item.timestamp).format(
        "MM/DD/YYYY HH:mm:ss",
      ),
      [AuditTrialTableColumnKeys.ACTIONS]:
        (item?.metadata?.name === "All"
          ? capitalizeWordsSeperatedByUnderScore(
              item?.metadata?.action_type || item?.metadata?.event_name,
            )
          : capitalizeWordsSeperatedByUnderScore(
              item?.metadata?.name ||
                item?.metadata?.action_type ||
                item?.metadata?.event_name,
            )) +
        " " +
        generateAdditionalData(item),

      [AuditTrialTableColumnKeys.EVENT_TYPE]: {
        text: generateBadgeForEventType(
          data?.tag ?? "",
          item?.metadata?.name ?? "",
        ),
        bgColor: generateBadgeForEventType(
          data?.tag ?? "",
          item?.metadata?.name ?? "",
        ).bgColor,
        color: generateBadgeForEventType(
          data?.tag ?? "",
          item?.metadata?.name ?? "",
        ).color,
      },
      [AuditTrialTableColumnKeys.VIEW_SCREENSHOT]: {
        shouldHideIcon:
          screenshotPath === undefined ||
          screenshotPath === null ||
          screenshotPath === "",
        screenshotPath: screenshotPath,
        shouldShowPdfIcon:
          item?.metadata?.doc_path && item?.metadata?.doc_type !== ""
            ? true
            : false,
        pdfPath: item?.metadata?.doc_path ?? "",
        title: capitalizeWordsSeperatedByUnderScore(
          checkForClickJS(item?.metadata?.name ?? ""),
        ),
      },

      [AuditTrialTableColumnKeys.ROW_DATA]: {
        ...item,
        order_id: data.order_id,
      },
    };
  });
};

const generateBadgeForEventType = (event_type: string, name: string) => {
  if (event_type.includes("api") && name.includes("gather_data_from_emr")) {
    return {
      text: EventTypeTextForUI[EventType.FHIR_API_CALL],
      bgColor: EventBadgeBgColorForUI[EventType.FHIR_API_CALL],
      color: EventBadgeTextColorForUI[EventType.FHIR_API_CALL],
    };
  } else if (
    event_type.includes("api") &&
    !name.includes("gather_data_from_emr")
  ) {
    return {
      text: EventTypeTextForUI[EventType.AI_AGENT],
      bgColor: EventBadgeBgColorForUI[EventType.AI_AGENT],
      color: EventBadgeTextColorForUI[EventType.AI_AGENT],
    };
  }
  return {
    text: EventTypeTextForUI[event_type ?? ""],
    bgColor: EventBadgeBgColorForUI[event_type ?? ""],
    color: EventBadgeTextColorForUI[event_type ?? ""],
  };
};
const checkForClickJS = (event_name: string) => {
  if (event_name.includes("click_javascript")) {
    event_name = event_name.replace("click_javascript", "click_web_element");
  }
  return event_name;
};
